// src/pages/DevMenuScreen.js
import React, { useState } from "react";
import { SafeAreaView, View, Text, StyleSheet, TextInput, TouchableOpacity } from "react-native";
import { useNavigation } from "@react-navigation/native";

const DARK_GREEN = "#0F3C2F";

export default function DevMenuScreen() {
const navigation = useNavigation();

const [taxiRef, setTaxiRef] = useState("CE508NO");
const [driverRef, setDriverRef] = useState("37069");

return (
<SafeAreaView style={S.safe}>
<View style={S.wrap}>
<Text style={S.h1}>DEV MENU</Text>
<Text style={S.p}>Accès rapide Taxi / Chauffeur (uniquement pour dev).</Text>

{/* Taxi */}
<View style={S.card}>
<Text style={S.cardTitle}>Taxi flow</Text>
<TextInput
value={taxiRef}
onChangeText={setTaxiRef}
placeholder="Immatriculation (ex: CE508NO)"
placeholderTextColor="rgba(17,24,39,0.35)"
style={S.input}
autoCapitalize="characters"
/>
<TouchableOpacity
activeOpacity={0.9}
style={S.btn}
onPress={() => navigation.navigate("home_screen", { ref: taxiRef })}
>
<Text style={S.btnText}>Ouvrir Taxi HomeScreen</Text>
</TouchableOpacity>

</View>

{/* Driver */}
<View style={S.card}>
<Text style={S.cardTitle}>Driver flow</Text>
<TextInput
value={driverRef}
onChangeText={setDriverRef}
placeholder="Driver ref (ex: 37069)"
placeholderTextColor="rgba(17,24,39,0.35)"
style={S.input}
autoCapitalize="characters"
/>
<TouchableOpacity
activeOpacity={0.9}
style={S.btn}
onPress={() => navigation.navigate("driver_home", { ref: driverRef })}
>
<Text style={S.btnText}>Ouvrir Driver HomeScreen</Text>
</TouchableOpacity>

</View>
</View>
</SafeAreaView>
);
}

const S = StyleSheet.create({
safe: { flex: 1, backgroundColor: "#EEF5F4" },
wrap: { flex: 1, padding: 18, gap: 14 },
h1: { fontSize: 22, fontWeight: "900", color: "#0B1F14" },
p: { fontSize: 13, fontWeight: "700", color: "rgba(11,31,20,0.65)", marginTop: -6 },

card: {
backgroundColor: "#FFFFFF",
borderRadius: 18,
padding: 14,
shadowColor: "#000",
shadowOpacity: 0.08,
shadowRadius: 18,
shadowOffset: { width: 0, height: 12 },
elevation: 3,
gap: 10,
},
cardTitle: { fontSize: 16, fontWeight: "900", color: "#1F6F3D" },

input: {
height: 46,
borderRadius: 14,
borderWidth: 1,
borderColor: "rgba(0,0,0,0.10)",
backgroundColor: "rgba(0,0,0,0.04)",
paddingHorizontal: 14,
fontSize: 16,
fontWeight: "800",
color: "#111827",
letterSpacing: 1,
},

btn: {
height: 44,
borderRadius: 14,
backgroundColor: DARK_GREEN,
alignItems: "center",
justifyContent: "center",
},
btnText: { color: "#FFFFFF", fontSize: 14, fontWeight: "900" },

btnGhost: { backgroundColor: "rgba(0,0,0,0.06)" },
btnTextGhost: { color: "#111827" },
});